<template>
  <div>
    <h4>Promo Code</h4>
    <small><em>*Promo codes cannot be applied retroactively</em></small>
    <hr>

    <div class="row">
      <div class="col">
        <input type="text" name="promo" class="form-control"
               placeholder="Enter a valid promo code"
               v-model="state.registrantData.promoCode">
        <button @click="checkPromo" type="button" class="btn btn-primary" style="margin-top:15px">Add Promocode</button>
      </div>
    </div>
    <br>
    <div v-if="this.state.registrantData.promoReferEmailRequired">
      <h4>Refer a Friend</h4>
      <hr>
      <div class="row">
        <div class="col">
          <input type="email" name="refer-email" class="form-control" placeholder=""
                 v-model="state.registrantData.promoReferEmail">
          <small>Enter an email address of someone who you think would be interested in NFCM, <strong>this is
            required in order for {{ state.registrantData.promoCode.toUpperCase() }} to complete
            checkout</strong></small>
        </div>
      </div>
      <br>
    </div>

  </div>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  name: 'Promo',

  computed: {
    ...mapGetters({
      state: 'getState',
    }),

  },
  methods: {

    checkPromo: function () {
      this.$store.dispatch('lookupPromoCode', this.state.registrantData.promoCode);

      if (this.state.registrantData.promoCode.toUpperCase() === "REFER50" || this.state.registrantData.promoCode.toUpperCase() === "REFER25") {
        this.$store.commit('makePromoReferEmailRequired');
      } else {
        this.$store.commit('makePromoReferEmailNotRequired');
      }

      if (this.state.registrantData.promoCode.toUpperCase() === "COMPMD" || this.state.registrantData.promoCode.toUpperCase() === "COMPNON") {
        this.$store.commit('makeFreeRegEligibiltyRequired');
      }

    },
    fieldClassName: function (field) {

      if (!field) {
        return ''
      }
      if ((field.$touched || field.$submitted) && field.$valid) {
        return 'has-success'
      }
      if ((field.$touched || field.$submitted) && field.$invalid) {
        return 'has-danger'
      }
    },
    onSubmit: function () {
      console.log(this.formstate.$valid)
    }
  },
}
</script>

<style scoped>
/* Section headings */
h4 {
  margin: 0 0 14px;
  padding: 16px 20px;

  background: linear-gradient(
      110deg,
      #148f94 0%,
      #427f9e 50%,
      #656dac 100%
  );

  border-bottom: 3px solid #80c9c5;
  border-radius: 12px;

  color: #ffffff;
  font-family: inherit;
  font-size: 22px;
  font-weight: 300;
  line-height: 1.35;
  letter-spacing: 0.025em;
  text-transform: uppercase;
}

/* Instructions and promo notice */
small {
  display: block;
  color: #657487;
  font-size: 13px;
  line-height: 1.6;
}

small em {
  display: block;
  padding: 0 4px;
  color: #536389;
}

small strong {
  color: #505a91;
  font-weight: 700;
}

hr {
  height: 1px;
  margin: 16px 0;
  border: 0;
  background: linear-gradient(
      to right,
      #80c9c5,
      #d9deef
  );
}

/* Form panels */
.row {
  margin: 0;
  padding: 20px;

  background: linear-gradient(
      135deg,
      #edf8f6 0%,
      #f0f1fa 100%
  );

  border: 1px solid #d5e1ea;
  border-radius: 14px;
  box-shadow: 0 5px 16px rgba(49, 75, 111, 0.07);
}

.row .col {
  min-width: 0;
  padding: 0;
}

/* Promo and referral inputs */
.form-control {
  box-sizing: border-box;
  display: block;
  width: 100%;
  height: auto;
  min-height: 48px;
  padding: 12px 15px;

  background: #ffffff;
  border: 1px solid #bfcfdd;
  border-radius: 9px;
  box-shadow: inset 0 1px 3px rgba(49, 75, 111, 0.04);

  color: #25354a;
  font-family: inherit;
  font-size: 15px;
  line-height: 1.5;

  transition:
      border-color 0.18s ease,
      box-shadow 0.18s ease;
}

.form-control::placeholder {
  color: #7b8799;
  opacity: 1;
}

.form-control:focus {
  outline: none;
  background: #ffffff;
  border-color: #168b91;
  box-shadow: 0 0 0 3px rgba(22, 139, 145, 0.16);
}

input[name="promo"] {
  font-weight: 600;
  letter-spacing: 0.025em;
}

input[name="refer-email"] {
  margin-bottom: 12px;
}

/* Add Promocode button */
.btn.btn-primary {
  display: inline-block;
  max-width: 100%;
  padding: 12px 24px;

  background: linear-gradient(
      110deg,
      #167b83 0%,
      #5866a3 100%
  );

  border: 0;
  border-radius: 9px;
  box-shadow: 0 4px 12px rgba(56, 92, 130, 0.20);

  color: #ffffff;
  font-family: inherit;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.5;
  white-space: normal;
  cursor: pointer;

  transition:
      filter 0.18s ease,
      box-shadow 0.18s ease;
}

.btn.btn-primary:hover {
  filter: brightness(0.9);
  box-shadow: 0 6px 16px rgba(56, 92, 130, 0.28);
  color: #ffffff;
}

.btn.btn-primary:focus-visible {
  outline: 3px solid #606fac;
  outline-offset: 4px;
}

/* Mobile adjustments */
@media (max-width: 600px) {
  h4 {
    padding: 14px 16px;
    font-size: 20px;
    border-radius: 10px;
  }

  .row {
    padding: 15px;
    border-radius: 11px;
  }

  .form-control {
    font-size: 16px;
  }

  .btn.btn-primary {
    width: 100%;
  }

  small {
    font-size: 12px;
  }
}

.required-field > label::after {
  content: '*';
  color: red;
  margin-left: 0.25rem;
}
</style>
